import { useTranslation } from 'react-i18next';

import styled from 'styled-components';

import { Button, Utils } from '@treezor/design-system';

import { IPaymentCard, PaymentCardActionName } from '@/features/cards/store/models/card.model';

import { setCardActions } from '@/store/actions/profile.actions';

import { useAppDispatch } from '@/hooks/redux-helpers';
import { useConfirmationDialog } from '@/hooks/useConfirmationModal';
import { useAccesControl } from '@/hooks/useAccessControl';

const EmptyTransactionsBlock = styled.div`
  text-align: center;
  margin: 10rem 0;
`;

const EmptyTransactionsTitle = styled.div`
  font-weight: ${(props) => props.theme.typography?.fontWeightBold};
  font-style: normal;
  font-size: 1.4rem;
  line-height: 1.575rem;
  color: ${(props) => props.theme.palette.secondary};
`;

const Subtitle = styled.div`
  font-weight: ${(props) => props.theme.typography?.fontWeightRegular};
  font-style: normal;
  font-size: 0.8rem;
  line-height: 1.3rem;
  color: ${(props) => Utils.hexColorAddOpacity(props.theme.palette.secondary, 0.5)};
`;

const ActivateCardContainer = styled.div`
  margin-top: 1rem;
`;
interface INotActivatedCardProps {
  paymentCard?: IPaymentCard;
}

export const NotActivatedCard = ({ paymentCard }: INotActivatedCardProps) => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const { hasAccessToFeature } = useAccesControl();

  const toggleActivatedCard = () => ActivateCard.toggle();

  const ActivateCard = useConfirmationDialog({
    id: 'confirmation-modal-activate-card',
    title: t('pages.currentProfiles.cards.card.notActivated.activate'),
    description: t('pages.currentProfiles.cards.card.notActivated.descriptionActivation', {
      cardId: paymentCard?.cardId,
      name: paymentCard?.embossedName,
      pan: Utils.maskedPan(paymentCard?.maskedPan),
    }),
    confirm: {
      label: t('pages.currentProfiles.cards.card.notActivated.confirmActivate'),
      color: 'success',
      action: () => handleActivateCard(PaymentCardActionName.ACTIVATE),
    },
  });

  const handleActivateCard = (action: PaymentCardActionName, payload?: IPaymentCard) => {
    if (!paymentCard) return;
    toggleActivatedCard();
    dispatch(setCardActions(paymentCard.userId, paymentCard.cardId, action, payload));
  };

  return (
    <>
      <EmptyTransactionsBlock>
        <EmptyTransactionsTitle>
          {t('pages.currentProfiles.cards.card.notActivated.modal.title')}
        </EmptyTransactionsTitle>
        <Subtitle>{t('pages.currentProfiles.cards.card.notActivated.modal.subtitle')}</Subtitle>
        {hasAccessToFeature(['EDIT_CARDS']) && (
          <ActivateCardContainer>
            <Button id="activate-card-btn" onClick={toggleActivatedCard}>
              {t('pages.currentProfiles.cards.card.notActivated.activate')}
            </Button>
          </ActivateCardContainer>
        )}
      </EmptyTransactionsBlock>

      <ActivateCard.ConfirmationDialog />
    </>
  );
};
